<template>
    <div class="about">
        <EditTemplate/>
    </div>
</template>

<script>
    import EditTemplate from '@/components/EditTemplate.vue'
	export default {
		name: 'EditTemplateView',
        components: {EditTemplate},
        data () {
            return {}
        },
	}
</script>